export default __webpack_public_path__ + "static/ourPartner1-4e20e9714369ed639d39c9907e15a29e.png";